// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Responsive adjustments for tablets and smaller desktops */
@media (max-width: 1024px) {
  .header-container,
  .admin-view-container,
  .access-management-section,
  .analytics-section,
  .time-filter {
    padding: 15px; /* Reduce padding for smaller screens */
    width: 95%; /* Increase width to utilize available space */
    margin: 10px auto; /* Center align and provide margin */
  }

  .metric-box,
  .dropdown select, .dropdown input,
  .search-input {
    font-size: 12px; /* Decrease font size for smaller elements */
  }

  .metric-box {
    height: auto; /* Make metric box height dynamic */
    padding: 10px; /* Reduce padding */
  }

  .user-table, .user-subtable {
    font-size: 0.8em; /* Reduce table font size */
  }

  .dropdown {
    flex-direction: row; /* Change dropdown direction for better fit */
    align-items: center;
    justify-content: space-between;
  }
} 

.admin-view-container {
  font-family: ui-sans-serif,-apple-system,system-ui,Segoe UI,Helvetica,Apple Color Emoji,Arial,sans-serif,Segoe UI Emoji,Segoe UI Symbol;
  flex-direction: column;
  width: 100%;
  height: 100%;
  color: #333; /* Dark grey for text for better readability */
  background-color: #f8f9fa; /* Light background to reduce strain */
  padding: 20px;
  align-items: stretch; 
}

.access-management-section {
  width: 100%;
  height: 100%;
  overflow-y:scroll;
  scrollbar-width: none;
  padding: 30px;
  padding-bottom: 8 0px;
  margin-bottom: 20px;
  border-radius: 8px;
  background-color: #e8e6f3;
}

.header{
  font-size: 18px;
  font-weight: 600;
  width: max-content; /* Width to fit content */
  color: #5e17eb; /* White text for contrast */
  display: inline-block; /* Ensures max-content respects the text width */
}

.header-container {
  font-size: 24px; 
  font-weight: 600; 
  margin-top: 0px; 
  display: flex; 
  flex-direction: row;
  justify-content: space-between; 
  align-items: center; /* Aligns items vertically */
  padding: 10px 20px; /* Adds padding around the content */
  border-radius: 8px; /* Rounds the corners */
  padding-left: 0px;
  width: 100%; /* Stretch across the full width of its container */
}

.header span{
  margin-right: 600px;
}

.dropdown {
  margin: 0 10px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  color: #717ff5; /* Keeping the purple theme */
  width: auto;
  border: 2px solid #ccc; 
  border-radius: 5px; 
  padding: 8px; 
  background-color: #fff; 
  box-shadow: 0 2px 5px rgba(0,0,0,0.1);
}

.dropdown label {
  margin-bottom: 0px;
  font-weight: bold;
  color: #717ff5; 
  font-family: ui-sans-serif,-apple-system,system-ui,Segoe UI,Helvetica,Apple Color Emoji,Arial,sans-serif,Segoe UI Emoji,Segoe UI Symbol;
}
.dropdown select, .dropdown input {
  padding: 5px; 
  border: none; /* Remove border */
  outline: none;
  border-radius: 5px;
  font-size: 14px;
  width: auto; /* Adjust the width as needed */
  color: #717ff5; /* Text color for the selected option */
  background-color: #fff; /* Background color of the dropdown */
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.3); /* Add box shadow */
  transition: box-shadow 0.3s ease; /* Smooth transition for the box shadow */
}

.dropdown select:hover, .dropdown input:hover {
  box-shadow: 0 6px 8px rgba(0, 0, 0, 0.20); /* Increase box shadow on hover */
}

.dropdown option {
  color: #717ff5; 
  background-color: whitesmoke;
}

.analytics-section {
  display: grid;
  align-content: center;
  width: 40%;
  height: max-content;
  grid-template-columns: repeat(2, 1fr); /* Creates two equal-width columns */
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  grid-template-rows: repeat(2, auto);   /* Creates two rows with auto height */
  grid-gap: 20px;
  margin-bottom: 20px;
  margin-right: 40px;
  border-radius: 8px;
  background-color: #E6E6FA; /* Light blue background for all main sections */
  padding: 20px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  align-items: start;
}


.metric-box {
  display: flex;
  align-items: center;
  background-color: #fff;
  border-radius: 8px;
  padding: 15px;
  box-shadow: 0px 0px 10px rgba(0,0,0,0.1);
  width: 100%;
  margin-bottom: 0px;
  height: 100px;
}

.metric-box:hover{
  transform: translateY(-3px);

}

.metric-icon {
  font-size: 2em;
  margin-right: 20px;
  color: #5e17eb;
}

.metric-text h3 {
  margin-right: 10px;
  font-size: 1.8em;
}
.metric-text h2 {
  margin-top: 8px;
  font-size: 1.2em;
}

.metric-text p {
  margin: 0;
  font-size: .9em;
  font-weight: 600;
  color: #555;
}

.time-filter {
  display: flex;
  flex-direction: row;
  width: 100%;
  margin-bottom: 20px;
  margin-top: -10px;
  z-index: 1;
  align-self: flex-end;
  justify-content: flex-end; /* Align content to the end of the row */
}


.time-filter label {
  margin-right: 10px;
  font-weight: bold;
}

.time-filter select {
  padding: 5px;
}

.access-management-content {
  padding: 20px;
  background-color: #E8F0F7;;
  border-radius: 8px;
  height: 300px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  margin-bottom: 20px;
}

.access-management-content {
  padding: 20px;
  background-color: #f0f4f8;
  border-radius: 8px;
}

.profile-of-people-section p,
.trending-questions p{
  color: #5e17eb;
}

.filter-controls {
  margin-bottom: 20px;
}

.department-filter {
  margin-left: 10px;
  padding: 5px;
  font-size: 0.9em;
}

.access_management_parent{
  display: flex;
  flex-direction: column; 
  width: 100%;
  margin-bottom: 50px;
}

.overview_parent{
  display: flex;
  flex-direction: row;
  width: 100%;
}

.search-input {
  padding: 8px 10px;
  font-size: 12px;
  border-radius: 5px;
  border: 2px solid #ccc;
  width: 200px; /* Adjust width as necessary */
  background-color: #fff;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.3);
}

.search-input:focus {
  outline: none;
  border-color: #5e17eb;
  box-shadow: 0 0 5px #5e17eb;
}

.search-input:hover {
  box-shadow: 0 6px 8px rgba(0, 0, 0, 0.20);
}

/* .documents{

}

.showReport{

} */

.user-category {
  width: 100%;
  height: 100%;
  flex-grow: 1;
  background:#fff;
  -webkit-backdrop-filter: blur(5px);
          backdrop-filter: blur(5px); /* Blur effect for the frosted glass look */
  border-radius: 8px; /* Rounded corners */
  padding: 0px 0px 20px 0px;
  margin-top: 10px;
}

.user-table {
  width: 100%;
  border-collapse: collapse;
  padding: 20px;
  background: rgba(255, 255, 255, 0.6); /* Light frosted effect */
}

.user-table thead {
  background-color: #5e17eb; /* A purple background as specified */
  color: #ffffff; /* White text color for contrast and readability */
}

.user-subtable {
  width: 75%;
  border-collapse: collapse;
}

.user-subtable thead {
  background-color: #424242; /* A purple background as specified */
  color: #fff; /* White text color for contrast and readability */
}

.user-table th, .user-table td, .user-subtable th, .user-subtable td {
  text-align: left;
  padding: 12px 10px; 
}

.upload-button {
  padding: 8px 12px;
  border: none;
  border-radius: 5px;
  background-color: #5e17eb; /* Primary button color */
  color: white;
  cursor: pointer; /* Indicates that the item is clickable */
  outline: none;
}

.upload-button:hover {
  background-color: #4d12c8; /* Darker shade on hover */
}

.status-button {
  padding: 5px 10px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 0.9em;
  background-color: #4a90e2;
}

.status-button:hover {
  background-color: #357ABD;
}

.status-button.enabled {
  background-color: #28a745;
  color: white;
}

.status-button.disabled {
  background-color: #dc3545;
  color: white;
}

.tooltip {
  position: absolute;
  top: 50%;
  left: 85px;
  transform: translateY(-50%);
  background-color: black;
  color: white;
  padding: 4px 8px;
  border-radius: 4px;
  white-space: nowrap;
  z-index: 1000;
  font-size: 12px;
}

.user-subtable td {
  background-color: #fff;
}

.search-input {
  padding: 8px 12px; /* Padding inside the input for better text visibility */
  font-size: 16px; /* Matches the size of input text with other elements */
  border: 2px solid #ccc; /* Light border for the input */
  border-radius: 8px; /* Rounded corners for the input */
  outline: none; /* Removes the default focus outline */
  width: 250px; /* Specifies a width for the input */
}


select {
  font-size: 14px;
  padding: 8px 12px;
  border: none;
  border-radius: 5px;
  background-color: #0056b3; /* Primary button color */
  color: white;
  cursor: pointer; /* Indicates that the item is clickable */
  outline: none;
}

select:focus {
  outline: none;
  border-color: #007bff;
  box-shadow: 0 0 5px rgba(0, 123, 255, 0.5);
}

select:hover{
  box-shadow: 0 6px 8px rgba(0, 0, 0, 0.20);
}

.custom-select-dropdown {
  font-size: 14px;
  padding: 8px 12px;
  border: 2px solid #5e17eb; /* Purple border matching theme */
  border-radius: 8px;
  background-color: #ffffff; /* White background */
  color: #333; /* Dark text for readability */
  cursor: pointer;
  outline: none;
  width: 65%; /* Adjust to full width of the container */
  /* -moz-appearance: none;
  -webkit-appearance: none; */
  position: relative;
  display: inline-block;
}

.custom-select-dropdown::after {
  content: '▼'; /* Use a more prominent arrow */
  font-size: 12px;
  color: #5e17eb; /* Arrow color to match the border */
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none; /* Non-interactable arrow */
}

.custom-select-dropdown:focus {
  border-color: #4a90e2;
  box-shadow: 0 0 5px rgba(94, 23, 235, 0.5); /* Focus shadow */
}

.custom-select-dropdown:hover {
  background-color: #e8e6f3; /* Light purple on hover */
  border-color: #4a90e2;
}

button {
  margin-right: 5px;
  padding: 5px 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  background-color: #f8f9fa;
  cursor: pointer;
}

button:hover {
  background-color: #e2e6ea;
}

button:focus {
  outline: none;
  border-color: #007bff;
}

.profile-of-people-section {
  width: max-content;
  padding: 30px;
  height: 260px;
  border-radius: 12px;
  margin-right: 40px;
  background-color: #fff;
  margin-bottom: 20px;
  box-shadow: 0 4px 8px rgba(0,0,0,0.05); /* Softer shadow to match UI style */
  border: 1px solid #eaeaea; /* Subtle border */
  
}

.trending-questions {
  height: 260px;
  width: max-content;
  padding: 30px;
  border: 1px solid #dee2e6;
  border-radius: 8px;
  background-color: #fff;
  box-shadow: 0px 0px 10px rgba(0,0,0,0.1);
  margin-bottom: 20px;
}

.scrollable-content {
  border-collapse: collapse;
  max-height: 160px; /* Adjust based on the total height minus the header */
  overflow-y: auto;
  scrollbar-width: thin;
}

.trending-questions h4 {
  margin-bottom: 0px;
  font-size: 1.25em;
  font-weight: bold;
  color: #343a40;
}

.trending-questions ul {
  list-style-type: none;
  padding-left: 10px;
  margin: 0;
}

.trending-questions li {
  padding: 5px 0;
  border-bottom: 1px solid #dee2e6;
  font-size: 1em;
  color: #343a40;
  list-style-type: none;
}

.trending-questions li:last-child {
  border-bottom: none;
}


.response-analytics-container {
  display: flex;
  flex-direction: row;  
  align-items: center;
  justify-content: space-between;
}

.semi-circle-progress-bar {
  position: relative;
  width: 100px;
  height: 50px;
  margin-left: 20px;
  margin-right: 20px;
}

.stats-column {
  display: flex;
  flex-direction: column;
  margin-left: 32px;
  margin-top: -40px;
  align-items: center;
  justify-content: center;
  
}

.stat {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  font-size: 1em;
  font-weight: 500;
}

/* Hide native tooltip */
.stat[data-tooltip] {
  position: relative;
  cursor: pointer;
}

.stat[data-tooltip]::after {
  content: attr(data-tooltip); /* Use the custom data attribute */
  position: absolute;
  background-color: #555;
  color: #fff;
  padding: 5px;
  border-radius: 5px;
  font-size: 16px;
  white-space: nowrap;
  bottom: 150%; /* Position above the element */
  left: 50%;
  transform: translateX(-50%);
  z-index: 1000;
  opacity: 0;
  transition: opacity 0.3s ease-in-out;
  pointer-events: none;
}

.stat[data-tooltip]::before {
  content: '';
  position: absolute;
  border-width: 5px;
  border-style: solid;
  border-color: #555 transparent transparent transparent;
  bottom: 115%; /* Position the arrow slightly above the tooltip */
  left: 50%;
  transform: translateX(-50%);
  opacity: 0;
  z-index: 1000;
  transition: opacity 0.3s ease-in-out;
  pointer-events: none;
}

.stat[data-tooltip]:hover::after,
.stat[data-tooltip]:hover::before {
  opacity: 1;
}

.stat i {
  margin-right: 5px;
  color: #007bff;
}


/* Additional styles for react-datepicker */
.react-datepicker__input-container input {
  width: auto;
  padding: 2.5px;
  padding-left: 10px;
  border: none;
  border-radius: 5px;
  color: #717ff5;
  font-size: 14px;
  background-color: #fff;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.3);
  transition: box-shadow 0.3s ease;
}
.dropdown label {
  margin-bottom: 0px;
  font-weight: bold;
  color: #717ff5;
  font-family: ui-sans-serif,-apple-system,system-ui,Segoe UI,Helvetica,Apple Color Emoji,Arial,sans-serif,Segoe UI Emoji,Segoe UI Symbol;
}

.react-datepicker__input-container input:hover {
  box-shadow: 0 6px 8px rgba(0, 0, 0, 0.20);
}

.react-datepicker__input-container input::placeholder {
  color: #717ff5;
}



/* Custom styles for react-datepicker calendar */
.react-datepicker {
  border: none;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.8);
}

.react-datepicker__header {
  background-color: #fff;
  border-bottom: none;

}

.react-datepicker__current-month,
.react-datepicker__day-name,
.react-datepicker__day,
.react-datepicker__time-name {
  
  color: #717ff5;
  

}

.react-datepicker__day--selected,
.react-datepicker__day--keyboard-selected,
.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected {
  background-color: #717ff5;
  color: #fff;
}

.react-datepicker__day--selected:hover,
.react-datepicker__day--keyboard-selected:hover,
.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected:hover {
  background-color: #5b6dc7;
}

.react-datepicker__day--today {
  font-weight: bold;
}

.react-datepicker__day--disabled,
.react-datepicker__day--excluded {
  color: #899bbd;;
  
}

.react-datepicker__navigation--previous,
.react-datepicker__navigation--next {
  top: 20px;
  line-height: 2.1rem;
  border: none;
  background: none;
}

.react-datepicker__navigation-icon {
  border-color: #717ff5;
}
/* Custom styles for time picker */
.react-datepicker {
  border: none;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.3);
  display: flex; /* NEW LINE */
  flex-direction: row; /* NEW LINE */
}
.react-datepicker__time-container {
  width: 100px;
  margin-right: 30%;
   /* Adjust the width as needed */
}

.react-datepicker__time-box {
  width: 100px; /* Adjust the width as needed */
}


.react-datepicker__current-month {
  margin-bottom: 5px; /* Add space below the current month */
}


.react-datepicker__week {
  margin-top: 2px; /* Add space above the week rows */
  margin-bottom: 2px; /* Add space below the week rows */
}

.modal-backdrop {
  background-color: rgba(0, 0, 0, 0.5); /* This makes the background darker/dull */
}


.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item {
  color: #717ff5; 
}

.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected {
  background-color: #717ff5; 
  color: #fff; 
}

.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected:hover {
  background-color: #5b6dc7; 
}

.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item:hover {
  background-color: #e6e8ff; 
}
.react-datepicker__time-container .react-datepicker-time__header {
  color: #717ff5;
}
/* Remove the black line between the calendar and time picker */
.react-datepicker__time-container {
  border-left: none; /* Remove the left border */
}
.error-message-container {
  display: flex;
  justify-content: flex-end;
  padding: 10px;
  
}
.react-datepicker__day--disabled,
.react-datepicker__time-list-item--disabled {
    color: darkgrey !important ;
        
}
.react-datepicker__time-list-item--disabled:hover { 
   cursor: not-allowed;
}
/* General dark theme adjustments */
.dark-mode {
  background-color: #121212; /* Dark background for the main area */
  color: #e0e0e0; /* Light text for readability */
}

.dark-mode .admin-view-container {
  background-color: #1e1e1e; /* Slightly lighter for better contrast */
  color: #e0e0e0;
}

.dark-mode .analytics-section {
  background-color: #666666;
}


.dark-mode .dropdown select, 
.dark-mode .dropdown input,
.dark-mode .search-input {
  background-color: #333; /* Dark background for input fields */
  color: #e0e0e0; /* Light text for visibility */
  border-color: #444; /* Dark border for inputs */
}

body.dark-mode .header {
  background-color: transparent;
}

.dark-mode .metric-box {
  background-color: #2c2c2c; /* Darker elements background */
  color: #e0e0e0; /* Ensure text is legible */
  padding: 12px 10px; 
}

.dark-mode .metric-box:hover {
  background-color: #333; /* Slightly lighter on hover for interaction feedback */
  box-shadow: 0 4px 8px rgba(255, 255, 255, 0.1); /* Soft white glow for depth */
}

.dark-mode .upload-button:hover,
.dark-mode .status-button:hover {
  background-color: #333; /* Slightly lighter on hover for interaction feedback */
}

.dark-mode .metric-icon {
  color: #B28DFF; /* Lighter shade for icons */
}

.dark-mode .metric-text p {
  color: #cccccc; /* Lighter text color */
}

.dark-mode .access-management-section {
  background-color: #1e1e1e; /* Darker shade for cards and sections */
  color: #e0e0e0;
  border: 1px solid #333; /* Subtle border for definition */
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); /* Softer shadows */
}

.dark-mode .profile-of-people-section p,
.dark-mode .trending-questions p{
  color: #E6E6FA;
}

.dark-mode .time-filter select, 
.dark-mode .search-input {
  background-color: #333; /* Dark background for input fields */
  color: #e0e0e0; /* Light text for visibility */
  border-color: #444; /* Dark border for inputs */
}

.dark-mode .user-category{
  background-color: transparent;
}

.dark-mode .user-table,
.dark-mode .user-subtable{
  background-color: #2c2c2c; /* Darker shade for cards and sections */
  color: #e0e0e0;
}

.dark-mode .user-table th,
.dark-mode .user-table td {
  padding: 12px 10px; /* Consistent padding */
}

.dark-mode .user-table th, 
.dark-mode .user-table td,
.dark-mode .user-subtable th, 
.dark-mode .user-subtable td {
  background-color: #2c2c2c; /* Darker background for tables */
  color: #e0e0e0;
}

.dark-mode .user-table th {
  background-color: #333333; /* Slightly lighter for headers */
  color: #e0e0e0;
}

.dark-mode .status-button.enabled {
  background-color: #28a745;
}

.dark-mode .status-button.disabled {
  background-color: #dc3545;
}

.dark-mode .profile-of-people-section {
  background-color: #1e1e1e; /* Darker shade for cards and sections */
  color: #e0e0e0;
  border: 1px solid #333; /* Subtle border for definition */
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); /* Softer shadows */
}

.dark-mode .trending-questions {
  background-color: #1e1e1e; /* Darker shade for cards and sections */
  color: #e0e0e0;
  border: 1px solid #333; /* Subtle border for definition */
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.dark-mode .trending-questions li {
  color: #fff;
}
.dark-mode .stat[data-tooltip]::after, 
.dark-mode .stat[data-tooltip]::before {
  background-color: #444444;
  border-color: #444444 transparent transparent transparent;
  color: #fff; /* Light text */
}

.dark-mode .send-button {
  color: #e0e0e0;
}

.dark-mode .send-button:hover {
  color: #4a90e2;
}

.dark-mode .remove-icon {
  color: #e0e0e0;
  background-color: rgba(255, 255, 255, 0.6);
}

.dark-mode .react-datepicker__input-container input {
  background-color: #2c2c2c;
  color: #e0e0e0;
}

.dark-mode .react-datepicker__day-name,
.dark-mode .react-datepicker__day,
.dark-mode .react-datepicker__time-name {
  color: #ccc;
}

.dark-mode .react-datepicker__day--selected,
.dark-mode .react-datepicker__day--keyboard-selected,
.dark-mode .react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected {
  background-color: #717ff5;
  color: #fff;
}

.dark-mode .dropdown option:selected {
  background-color: #717ff5; /* Highlight color */
  color: #fff;
}

.dark-mode .react-datepicker__day--disabled,
.dark-mode .react-datepicker__day--excluded {
  color: #555;
}

.dark-mode .react-datepicker__navigation-icon {
  border-color: #717ff5;
}

.dark-mode .user-subtable th, .dark-mode .user-subtable td {
  padding: 10px;
  background-color: #2c2c2c;
  color: #e0e0e0;
}

.dark-mode .user-subtable th {
  background-color: #333333;
}
.dark-mode .semi-circle {
  background: conic-gradient(#00aaff 0deg, #2c2c2c 0deg);
}
.dark-mode .percentage-label {
  color: #fff;
}

.dark-mode .documents .modal-content{
  background-color: #2e2e2e; /* Dark background */
  color: #ffffff; /* Light text color */
}

.dark-mode .documents .modal-footer, .dark-mode .documents .modal-header{
  border-color: #444444; /* Dark borders */
}

.dark-mode .showReport .modal-content{
  background-color: #2e2e2e; /* Dark background */
  color: #ffffff; /* Light text color */
}

.dark-mode .showReport .modal-footer, .dark-mode .documents .modal-header{
  border-color: #444444; /* Dark borders */
}`, "",{"version":3,"sources":["webpack://./src/components/AdminView.css"],"names":[],"mappings":"AAAA,4DAA4D;AAC5D;EACE;;;;;IAKE,aAAa,EAAE,uCAAuC;IACtD,UAAU,EAAE,8CAA8C;IAC1D,iBAAiB,EAAE,oCAAoC;EACzD;;EAEA;;;IAGE,eAAe,EAAE,4CAA4C;EAC/D;;EAEA;IACE,YAAY,EAAE,mCAAmC;IACjD,aAAa,EAAE,mBAAmB;EACpC;;EAEA;IACE,gBAAgB,EAAE,2BAA2B;EAC/C;;EAEA;IACE,mBAAmB,EAAE,6CAA6C;IAClE,mBAAmB;IACnB,8BAA8B;EAChC;AACF;;AAEA;EACE,uIAAuI;EACvI,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,WAAW,EAAE,8CAA8C;EAC3D,yBAAyB,EAAE,sCAAsC;EACjE,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,qBAAqB;EACrB,aAAa;EACb,qBAAqB;EACrB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB,EAAE,yBAAyB;EAC7C,cAAc,EAAE,4BAA4B;EAC5C,qBAAqB,EAAE,gDAAgD;AACzE;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB,EAAE,4BAA4B;EACjD,kBAAkB,EAAE,oCAAoC;EACxD,kBAAkB,EAAE,uBAAuB;EAC3C,iBAAiB;EACjB,WAAW,EAAE,mDAAmD;AAClE;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,cAAc,EAAE,6BAA6B;EAC7C,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,sBAAsB;EACtB,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,uIAAuI;AACzI;AACA;EACE,YAAY;EACZ,YAAY,EAAE,kBAAkB;EAChC,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,WAAW,EAAE,+BAA+B;EAC5C,cAAc,EAAE,uCAAuC;EACvD,sBAAsB,EAAE,qCAAqC;EAC7D,wCAAwC,EAAE,mBAAmB;EAC7D,gCAAgC,EAAE,yCAAyC;AAC7E;;AAEA;EACE,yCAAyC,EAAE,iCAAiC;AAC9E;;AAEA;EACE,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,UAAU;EACV,mBAAmB;EACnB,qCAAqC,EAAE,oCAAoC;EAC3E,4DAA4D;EAC5D,mCAAmC,IAAI,sCAAsC;EAC7E,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB,EAAE,gDAAgD;EAC3E,aAAa;EACb,yCAAyC;EACzC,kBAAkB;AACpB;;;AAGA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,wCAAwC;EACxC,WAAW;EACX,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,2BAA2B;;AAE7B;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,iBAAiB;EACjB,UAAU;EACV,oBAAoB;EACpB,yBAAyB,EAAE,wCAAwC;AACrE;;;AAGA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,yCAAyC;EACzC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,sBAAsB;EACtB,YAAY,EAAE,8BAA8B;EAC5C,sBAAsB;EACtB,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;;;;;;GAMG;;AAEH;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,kCAA0B;UAA1B,0BAA0B,EAAE,2CAA2C;EACvE,kBAAkB,EAAE,oBAAoB;EACxC,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,aAAa;EACb,oCAAoC,EAAE,yBAAyB;AACjE;;AAEA;EACE,yBAAyB,EAAE,qCAAqC;EAChE,cAAc,EAAE,kDAAkD;AACpE;;AAEA;EACE,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB,EAAE,qCAAqC;EAChE,WAAW,EAAE,kDAAkD;AACjE;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,yBAAyB,EAAE,yBAAyB;EACpD,YAAY;EACZ,eAAe,EAAE,yCAAyC;EAC1D,aAAa;AACf;;AAEA;EACE,yBAAyB,EAAE,0BAA0B;AACvD;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,2BAA2B;EAC3B,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,iBAAiB,EAAE,wDAAwD;EAC3E,eAAe,EAAE,uDAAuD;EACxE,sBAAsB,EAAE,+BAA+B;EACvD,kBAAkB,EAAE,kCAAkC;EACtD,aAAa,EAAE,sCAAsC;EACrD,YAAY,EAAE,oCAAoC;AACpD;;;AAGA;EACE,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,yBAAyB,EAAE,yBAAyB;EACpD,YAAY;EACZ,eAAe,EAAE,yCAAyC;EAC1D,aAAa;AACf;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,0CAA0C;AAC5C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,yBAAyB,EAAE,iCAAiC;EAC5D,kBAAkB;EAClB,yBAAyB,EAAE,qBAAqB;EAChD,WAAW,EAAE,8BAA8B;EAC3C,eAAe;EACf,aAAa;EACb,UAAU,EAAE,0CAA0C;EACtD;6BAC2B;EAC3B,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,YAAY,EAAE,+BAA+B;EAC7C,eAAe;EACf,cAAc,EAAE,oCAAoC;EACpD,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,oBAAoB,EAAE,2BAA2B;AACnD;;AAEA;EACE,qBAAqB;EACrB,0CAA0C,EAAE,iBAAiB;AAC/D;;AAEA;EACE,yBAAyB,EAAE,0BAA0B;EACrD,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;EACnB,sCAAsC,EAAE,oCAAoC;EAC5E,yBAAyB,EAAE,kBAAkB;;AAE/C;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,sBAAsB;EACtB,wCAAwC;EACxC,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB,EAAE,sDAAsD;EACzE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,gCAAgC;EAChC,cAAc;EACd,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;;AAGA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,uBAAuB;;AAEzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA,wBAAwB;AACxB;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,2BAA2B,EAAE,kCAAkC;EAC/D,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,YAAY,EAAE,+BAA+B;EAC7C,SAAS;EACT,2BAA2B;EAC3B,aAAa;EACb,UAAU;EACV,oCAAoC;EACpC,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,sDAAsD;EACtD,YAAY,EAAE,kDAAkD;EAChE,SAAS;EACT,2BAA2B;EAC3B,UAAU;EACV,aAAa;EACb,oCAAoC;EACpC,oBAAoB;AACtB;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;;AAGA,2CAA2C;AAC3C;EACE,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,sBAAsB;EACtB,wCAAwC;EACxC,gCAAgC;AAClC;AACA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,uIAAuI;AACzI;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,cAAc;AAChB;;;;AAIA,gDAAgD;AAChD;EACE,YAAY;EACZ,wCAAwC;AAC1C;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;;AAErB;;AAEA;;;;;EAKE,cAAc;;;AAGhB;;AAEA;;;EAGE,yBAAyB;EACzB,WAAW;AACb;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;EAEE,cAAc;;AAEhB;;AAEA;;EAEE,SAAS;EACT,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;AACA,kCAAkC;AAClC;EACE,YAAY;EACZ,wCAAwC;EACxC,aAAa,EAAE,aAAa;EAC5B,mBAAmB,EAAE,aAAa;AACpC;AACA;EACE,YAAY;EACZ,iBAAiB;GAChB,+BAA+B;AAClC;;AAEA;EACE,YAAY,EAAE,+BAA+B;AAC/C;;;AAGA;EACE,kBAAkB,EAAE,sCAAsC;AAC5D;;;AAGA;EACE,eAAe,EAAE,kCAAkC;EACnD,kBAAkB,EAAE,kCAAkC;AACxD;;AAEA;EACE,oCAAoC,EAAE,0CAA0C;AAClF;;;AAGA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,cAAc;AAChB;AACA,+DAA+D;AAC/D;EACE,iBAAiB,EAAE,2BAA2B;AAChD;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,aAAa;;AAEf;AACA;;IAEI,2BAA2B;;AAE/B;AACA;GACG,mBAAmB;AACtB;AACA,mCAAmC;AACnC;EACE,yBAAyB,EAAE,sCAAsC;EACjE,cAAc,EAAE,+BAA+B;AACjD;;AAEA;EACE,yBAAyB,EAAE,yCAAyC;EACpE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;;AAGA;;;EAGE,sBAAsB,EAAE,qCAAqC;EAC7D,cAAc,EAAE,8BAA8B;EAC9C,kBAAkB,EAAE,2BAA2B;AACjD;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB,EAAE,+BAA+B;EAC1D,cAAc,EAAE,2BAA2B;EAC3C,kBAAkB;AACpB;;AAEA;EACE,sBAAsB,EAAE,uDAAuD;EAC/E,8CAA8C,EAAE,8BAA8B;AAChF;;AAEA;;EAEE,sBAAsB,EAAE,uDAAuD;AACjF;;AAEA;EACE,cAAc,EAAE,4BAA4B;AAC9C;;AAEA;EACE,cAAc,EAAE,uBAAuB;AACzC;;AAEA;EACE,yBAAyB,EAAE,wCAAwC;EACnE,cAAc;EACd,sBAAsB,EAAE,iCAAiC;EACzD,wCAAwC,EAAE,mBAAmB;AAC/D;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,sBAAsB,EAAE,qCAAqC;EAC7D,cAAc,EAAE,8BAA8B;EAC9C,kBAAkB,EAAE,2BAA2B;AACjD;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;;EAEE,yBAAyB,EAAE,wCAAwC;EACnE,cAAc;AAChB;;AAEA;;EAEE,kBAAkB,EAAE,uBAAuB;AAC7C;;AAEA;;;;EAIE,yBAAyB,EAAE,iCAAiC;EAC5D,cAAc;AAChB;;AAEA;EACE,yBAAyB,EAAE,iCAAiC;EAC5D,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB,EAAE,wCAAwC;EACnE,cAAc;EACd,sBAAsB,EAAE,iCAAiC;EACzD,wCAAwC,EAAE,mBAAmB;AAC/D;;AAEA;EACE,yBAAyB,EAAE,wCAAwC;EACnE,cAAc;EACd,sBAAsB,EAAE,iCAAiC;EACzD,wCAAwC;AAC1C;;AAEA;EACE,WAAW;AACb;AACA;;EAEE,yBAAyB;EACzB,yDAAyD;EACzD,WAAW,EAAE,eAAe;AAC9B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;;;EAGE,WAAW;AACb;;AAEA;;;EAGE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB,EAAE,oBAAoB;EAC/C,WAAW;AACb;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,sDAAsD;AACxD;AACA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB,EAAE,oBAAoB;EAC/C,cAAc,EAAE,qBAAqB;AACvC;;AAEA;EACE,qBAAqB,EAAE,iBAAiB;AAC1C;;AAEA;EACE,yBAAyB,EAAE,oBAAoB;EAC/C,cAAc,EAAE,qBAAqB;AACvC;;AAEA;EACE,qBAAqB,EAAE,iBAAiB;AAC1C","sourcesContent":["/* Responsive adjustments for tablets and smaller desktops */\n@media (max-width: 1024px) {\n  .header-container,\n  .admin-view-container,\n  .access-management-section,\n  .analytics-section,\n  .time-filter {\n    padding: 15px; /* Reduce padding for smaller screens */\n    width: 95%; /* Increase width to utilize available space */\n    margin: 10px auto; /* Center align and provide margin */\n  }\n\n  .metric-box,\n  .dropdown select, .dropdown input,\n  .search-input {\n    font-size: 12px; /* Decrease font size for smaller elements */\n  }\n\n  .metric-box {\n    height: auto; /* Make metric box height dynamic */\n    padding: 10px; /* Reduce padding */\n  }\n\n  .user-table, .user-subtable {\n    font-size: 0.8em; /* Reduce table font size */\n  }\n\n  .dropdown {\n    flex-direction: row; /* Change dropdown direction for better fit */\n    align-items: center;\n    justify-content: space-between;\n  }\n} \n\n.admin-view-container {\n  font-family: ui-sans-serif,-apple-system,system-ui,Segoe UI,Helvetica,Apple Color Emoji,Arial,sans-serif,Segoe UI Emoji,Segoe UI Symbol;\n  flex-direction: column;\n  width: 100%;\n  height: 100%;\n  color: #333; /* Dark grey for text for better readability */\n  background-color: #f8f9fa; /* Light background to reduce strain */\n  padding: 20px;\n  align-items: stretch; \n}\n\n.access-management-section {\n  width: 100%;\n  height: 100%;\n  overflow-y:scroll;\n  scrollbar-width: none;\n  padding: 30px;\n  padding-bottom: 8 0px;\n  margin-bottom: 20px;\n  border-radius: 8px;\n  background-color: #e8e6f3;\n}\n\n.header{\n  font-size: 18px;\n  font-weight: 600;\n  width: max-content; /* Width to fit content */\n  color: #5e17eb; /* White text for contrast */\n  display: inline-block; /* Ensures max-content respects the text width */\n}\n\n.header-container {\n  font-size: 24px; \n  font-weight: 600; \n  margin-top: 0px; \n  display: flex; \n  flex-direction: row;\n  justify-content: space-between; \n  align-items: center; /* Aligns items vertically */\n  padding: 10px 20px; /* Adds padding around the content */\n  border-radius: 8px; /* Rounds the corners */\n  padding-left: 0px;\n  width: 100%; /* Stretch across the full width of its container */\n}\n\n.header span{\n  margin-right: 600px;\n}\n\n.dropdown {\n  margin: 0 10px;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  color: #717ff5; /* Keeping the purple theme */\n  width: auto;\n  border: 2px solid #ccc; \n  border-radius: 5px; \n  padding: 8px; \n  background-color: #fff; \n  box-shadow: 0 2px 5px rgba(0,0,0,0.1);\n}\n\n.dropdown label {\n  margin-bottom: 0px;\n  font-weight: bold;\n  color: #717ff5; \n  font-family: ui-sans-serif,-apple-system,system-ui,Segoe UI,Helvetica,Apple Color Emoji,Arial,sans-serif,Segoe UI Emoji,Segoe UI Symbol;\n}\n.dropdown select, .dropdown input {\n  padding: 5px; \n  border: none; /* Remove border */\n  outline: none;\n  border-radius: 5px;\n  font-size: 14px;\n  width: auto; /* Adjust the width as needed */\n  color: #717ff5; /* Text color for the selected option */\n  background-color: #fff; /* Background color of the dropdown */\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.3); /* Add box shadow */\n  transition: box-shadow 0.3s ease; /* Smooth transition for the box shadow */\n}\n\n.dropdown select:hover, .dropdown input:hover {\n  box-shadow: 0 6px 8px rgba(0, 0, 0, 0.20); /* Increase box shadow on hover */\n}\n\n.dropdown option {\n  color: #717ff5; \n  background-color: whitesmoke;\n}\n\n.analytics-section {\n  display: grid;\n  align-content: center;\n  width: 40%;\n  height: max-content;\n  grid-template-columns: repeat(2, 1fr); /* Creates two equal-width columns */\n  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));\n  grid-template-rows: repeat(2, auto);   /* Creates two rows with auto height */\n  grid-gap: 20px;\n  margin-bottom: 20px;\n  margin-right: 40px;\n  border-radius: 8px;\n  background-color: #E6E6FA; /* Light blue background for all main sections */\n  padding: 20px;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n  align-items: start;\n}\n\n\n.metric-box {\n  display: flex;\n  align-items: center;\n  background-color: #fff;\n  border-radius: 8px;\n  padding: 15px;\n  box-shadow: 0px 0px 10px rgba(0,0,0,0.1);\n  width: 100%;\n  margin-bottom: 0px;\n  height: 100px;\n}\n\n.metric-box:hover{\n  transform: translateY(-3px);\n\n}\n\n.metric-icon {\n  font-size: 2em;\n  margin-right: 20px;\n  color: #5e17eb;\n}\n\n.metric-text h3 {\n  margin-right: 10px;\n  font-size: 1.8em;\n}\n.metric-text h2 {\n  margin-top: 8px;\n  font-size: 1.2em;\n}\n\n.metric-text p {\n  margin: 0;\n  font-size: .9em;\n  font-weight: 600;\n  color: #555;\n}\n\n.time-filter {\n  display: flex;\n  flex-direction: row;\n  width: 100%;\n  margin-bottom: 20px;\n  margin-top: -10px;\n  z-index: 1;\n  align-self: flex-end;\n  justify-content: flex-end; /* Align content to the end of the row */\n}\n\n\n.time-filter label {\n  margin-right: 10px;\n  font-weight: bold;\n}\n\n.time-filter select {\n  padding: 5px;\n}\n\n.access-management-content {\n  padding: 20px;\n  background-color: #E8F0F7;;\n  border-radius: 8px;\n  height: 300px;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n  margin-bottom: 20px;\n}\n\n.access-management-content {\n  padding: 20px;\n  background-color: #f0f4f8;\n  border-radius: 8px;\n}\n\n.profile-of-people-section p,\n.trending-questions p{\n  color: #5e17eb;\n}\n\n.filter-controls {\n  margin-bottom: 20px;\n}\n\n.department-filter {\n  margin-left: 10px;\n  padding: 5px;\n  font-size: 0.9em;\n}\n\n.access_management_parent{\n  display: flex;\n  flex-direction: column; \n  width: 100%;\n  margin-bottom: 50px;\n}\n\n.overview_parent{\n  display: flex;\n  flex-direction: row;\n  width: 100%;\n}\n\n.search-input {\n  padding: 8px 10px;\n  font-size: 12px;\n  border-radius: 5px;\n  border: 2px solid #ccc;\n  width: 200px; /* Adjust width as necessary */\n  background-color: #fff;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.3);\n}\n\n.search-input:focus {\n  outline: none;\n  border-color: #5e17eb;\n  box-shadow: 0 0 5px #5e17eb;\n}\n\n.search-input:hover {\n  box-shadow: 0 6px 8px rgba(0, 0, 0, 0.20);\n}\n\n/* .documents{\n\n}\n\n.showReport{\n\n} */\n\n.user-category {\n  width: 100%;\n  height: 100%;\n  flex-grow: 1;\n  background:#fff;\n  backdrop-filter: blur(5px); /* Blur effect for the frosted glass look */\n  border-radius: 8px; /* Rounded corners */\n  padding: 0px 0px 20px 0px;\n  margin-top: 10px;\n}\n\n.user-table {\n  width: 100%;\n  border-collapse: collapse;\n  padding: 20px;\n  background: rgba(255, 255, 255, 0.6); /* Light frosted effect */\n}\n\n.user-table thead {\n  background-color: #5e17eb; /* A purple background as specified */\n  color: #ffffff; /* White text color for contrast and readability */\n}\n\n.user-subtable {\n  width: 75%;\n  border-collapse: collapse;\n}\n\n.user-subtable thead {\n  background-color: #424242; /* A purple background as specified */\n  color: #fff; /* White text color for contrast and readability */\n}\n\n.user-table th, .user-table td, .user-subtable th, .user-subtable td {\n  text-align: left;\n  padding: 12px 10px; \n}\n\n.upload-button {\n  padding: 8px 12px;\n  border: none;\n  border-radius: 5px;\n  background-color: #5e17eb; /* Primary button color */\n  color: white;\n  cursor: pointer; /* Indicates that the item is clickable */\n  outline: none;\n}\n\n.upload-button:hover {\n  background-color: #4d12c8; /* Darker shade on hover */\n}\n\n.status-button {\n  padding: 5px 10px;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  font-size: 0.9em;\n  background-color: #4a90e2;\n}\n\n.status-button:hover {\n  background-color: #357ABD;\n}\n\n.status-button.enabled {\n  background-color: #28a745;\n  color: white;\n}\n\n.status-button.disabled {\n  background-color: #dc3545;\n  color: white;\n}\n\n.tooltip {\n  position: absolute;\n  top: 50%;\n  left: 85px;\n  transform: translateY(-50%);\n  background-color: black;\n  color: white;\n  padding: 4px 8px;\n  border-radius: 4px;\n  white-space: nowrap;\n  z-index: 1000;\n  font-size: 12px;\n}\n\n.user-subtable td {\n  background-color: #fff;\n}\n\n.search-input {\n  padding: 8px 12px; /* Padding inside the input for better text visibility */\n  font-size: 16px; /* Matches the size of input text with other elements */\n  border: 2px solid #ccc; /* Light border for the input */\n  border-radius: 8px; /* Rounded corners for the input */\n  outline: none; /* Removes the default focus outline */\n  width: 250px; /* Specifies a width for the input */\n}\n\n\nselect {\n  font-size: 14px;\n  padding: 8px 12px;\n  border: none;\n  border-radius: 5px;\n  background-color: #0056b3; /* Primary button color */\n  color: white;\n  cursor: pointer; /* Indicates that the item is clickable */\n  outline: none;\n}\n\nselect:focus {\n  outline: none;\n  border-color: #007bff;\n  box-shadow: 0 0 5px rgba(0, 123, 255, 0.5);\n}\n\nselect:hover{\n  box-shadow: 0 6px 8px rgba(0, 0, 0, 0.20);\n}\n\n.custom-select-dropdown {\n  font-size: 14px;\n  padding: 8px 12px;\n  border: 2px solid #5e17eb; /* Purple border matching theme */\n  border-radius: 8px;\n  background-color: #ffffff; /* White background */\n  color: #333; /* Dark text for readability */\n  cursor: pointer;\n  outline: none;\n  width: 65%; /* Adjust to full width of the container */\n  /* -moz-appearance: none;\n  -webkit-appearance: none; */\n  position: relative;\n  display: inline-block;\n}\n\n.custom-select-dropdown::after {\n  content: '▼'; /* Use a more prominent arrow */\n  font-size: 12px;\n  color: #5e17eb; /* Arrow color to match the border */\n  position: absolute;\n  right: 10px;\n  top: 50%;\n  transform: translateY(-50%);\n  pointer-events: none; /* Non-interactable arrow */\n}\n\n.custom-select-dropdown:focus {\n  border-color: #4a90e2;\n  box-shadow: 0 0 5px rgba(94, 23, 235, 0.5); /* Focus shadow */\n}\n\n.custom-select-dropdown:hover {\n  background-color: #e8e6f3; /* Light purple on hover */\n  border-color: #4a90e2;\n}\n\nbutton {\n  margin-right: 5px;\n  padding: 5px 10px;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  background-color: #f8f9fa;\n  cursor: pointer;\n}\n\nbutton:hover {\n  background-color: #e2e6ea;\n}\n\nbutton:focus {\n  outline: none;\n  border-color: #007bff;\n}\n\n.profile-of-people-section {\n  width: max-content;\n  padding: 30px;\n  height: 260px;\n  border-radius: 12px;\n  margin-right: 40px;\n  background-color: #fff;\n  margin-bottom: 20px;\n  box-shadow: 0 4px 8px rgba(0,0,0,0.05); /* Softer shadow to match UI style */\n  border: 1px solid #eaeaea; /* Subtle border */\n  \n}\n\n.trending-questions {\n  height: 260px;\n  width: max-content;\n  padding: 30px;\n  border: 1px solid #dee2e6;\n  border-radius: 8px;\n  background-color: #fff;\n  box-shadow: 0px 0px 10px rgba(0,0,0,0.1);\n  margin-bottom: 20px;\n}\n\n.scrollable-content {\n  border-collapse: collapse;\n  max-height: 160px; /* Adjust based on the total height minus the header */\n  overflow-y: auto;\n  scrollbar-width: thin;\n}\n\n.trending-questions h4 {\n  margin-bottom: 0px;\n  font-size: 1.25em;\n  font-weight: bold;\n  color: #343a40;\n}\n\n.trending-questions ul {\n  list-style-type: none;\n  padding-left: 10px;\n  margin: 0;\n}\n\n.trending-questions li {\n  padding: 5px 0;\n  border-bottom: 1px solid #dee2e6;\n  font-size: 1em;\n  color: #343a40;\n  list-style-type: none;\n}\n\n.trending-questions li:last-child {\n  border-bottom: none;\n}\n\n\n.response-analytics-container {\n  display: flex;\n  flex-direction: row;  \n  align-items: center;\n  justify-content: space-between;\n}\n\n.semi-circle-progress-bar {\n  position: relative;\n  width: 100px;\n  height: 50px;\n  margin-left: 20px;\n  margin-right: 20px;\n}\n\n.stats-column {\n  display: flex;\n  flex-direction: column;\n  margin-left: 32px;\n  margin-top: -40px;\n  align-items: center;\n  justify-content: center;\n  \n}\n\n.stat {\n  display: flex;\n  align-items: center;\n  margin-bottom: 10px;\n  font-size: 1em;\n  font-weight: 500;\n}\n\n/* Hide native tooltip */\n.stat[data-tooltip] {\n  position: relative;\n  cursor: pointer;\n}\n\n.stat[data-tooltip]::after {\n  content: attr(data-tooltip); /* Use the custom data attribute */\n  position: absolute;\n  background-color: #555;\n  color: #fff;\n  padding: 5px;\n  border-radius: 5px;\n  font-size: 16px;\n  white-space: nowrap;\n  bottom: 150%; /* Position above the element */\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: 1000;\n  opacity: 0;\n  transition: opacity 0.3s ease-in-out;\n  pointer-events: none;\n}\n\n.stat[data-tooltip]::before {\n  content: '';\n  position: absolute;\n  border-width: 5px;\n  border-style: solid;\n  border-color: #555 transparent transparent transparent;\n  bottom: 115%; /* Position the arrow slightly above the tooltip */\n  left: 50%;\n  transform: translateX(-50%);\n  opacity: 0;\n  z-index: 1000;\n  transition: opacity 0.3s ease-in-out;\n  pointer-events: none;\n}\n\n.stat[data-tooltip]:hover::after,\n.stat[data-tooltip]:hover::before {\n  opacity: 1;\n}\n\n.stat i {\n  margin-right: 5px;\n  color: #007bff;\n}\n\n\n/* Additional styles for react-datepicker */\n.react-datepicker__input-container input {\n  width: auto;\n  padding: 2.5px;\n  padding-left: 10px;\n  border: none;\n  border-radius: 5px;\n  color: #717ff5;\n  font-size: 14px;\n  background-color: #fff;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.3);\n  transition: box-shadow 0.3s ease;\n}\n.dropdown label {\n  margin-bottom: 0px;\n  font-weight: bold;\n  color: #717ff5;\n  font-family: ui-sans-serif,-apple-system,system-ui,Segoe UI,Helvetica,Apple Color Emoji,Arial,sans-serif,Segoe UI Emoji,Segoe UI Symbol;\n}\n\n.react-datepicker__input-container input:hover {\n  box-shadow: 0 6px 8px rgba(0, 0, 0, 0.20);\n}\n\n.react-datepicker__input-container input::placeholder {\n  color: #717ff5;\n}\n\n\n\n/* Custom styles for react-datepicker calendar */\n.react-datepicker {\n  border: none;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.8);\n}\n\n.react-datepicker__header {\n  background-color: #fff;\n  border-bottom: none;\n\n}\n\n.react-datepicker__current-month,\n.react-datepicker__day-name,\n.react-datepicker__day,\n.react-datepicker__time-name {\n  \n  color: #717ff5;\n  \n\n}\n\n.react-datepicker__day--selected,\n.react-datepicker__day--keyboard-selected,\n.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected {\n  background-color: #717ff5;\n  color: #fff;\n}\n\n.react-datepicker__day--selected:hover,\n.react-datepicker__day--keyboard-selected:hover,\n.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected:hover {\n  background-color: #5b6dc7;\n}\n\n.react-datepicker__day--today {\n  font-weight: bold;\n}\n\n.react-datepicker__day--disabled,\n.react-datepicker__day--excluded {\n  color: #899bbd;;\n  \n}\n\n.react-datepicker__navigation--previous,\n.react-datepicker__navigation--next {\n  top: 20px;\n  line-height: 2.1rem;\n  border: none;\n  background: none;\n}\n\n.react-datepicker__navigation-icon {\n  border-color: #717ff5;\n}\n/* Custom styles for time picker */\n.react-datepicker {\n  border: none;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.3);\n  display: flex; /* NEW LINE */\n  flex-direction: row; /* NEW LINE */\n}\n.react-datepicker__time-container {\n  width: 100px;\n  margin-right: 30%;\n   /* Adjust the width as needed */\n}\n\n.react-datepicker__time-box {\n  width: 100px; /* Adjust the width as needed */\n}\n\n\n.react-datepicker__current-month {\n  margin-bottom: 5px; /* Add space below the current month */\n}\n\n\n.react-datepicker__week {\n  margin-top: 2px; /* Add space above the week rows */\n  margin-bottom: 2px; /* Add space below the week rows */\n}\n\n.modal-backdrop {\n  background-color: rgba(0, 0, 0, 0.5); /* This makes the background darker/dull */\n}\n\n\n.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item {\n  color: #717ff5; \n}\n\n.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected {\n  background-color: #717ff5; \n  color: #fff; \n}\n\n.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected:hover {\n  background-color: #5b6dc7; \n}\n\n.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item:hover {\n  background-color: #e6e8ff; \n}\n.react-datepicker__time-container .react-datepicker-time__header {\n  color: #717ff5;\n}\n/* Remove the black line between the calendar and time picker */\n.react-datepicker__time-container {\n  border-left: none; /* Remove the left border */\n}\n.error-message-container {\n  display: flex;\n  justify-content: flex-end;\n  padding: 10px;\n  \n}\n.react-datepicker__day--disabled,\n.react-datepicker__time-list-item--disabled {\n    color: darkgrey !important ;\n        \n}\n.react-datepicker__time-list-item--disabled:hover { \n   cursor: not-allowed;\n}\n/* General dark theme adjustments */\n.dark-mode {\n  background-color: #121212; /* Dark background for the main area */\n  color: #e0e0e0; /* Light text for readability */\n}\n\n.dark-mode .admin-view-container {\n  background-color: #1e1e1e; /* Slightly lighter for better contrast */\n  color: #e0e0e0;\n}\n\n.dark-mode .analytics-section {\n  background-color: #666666;\n}\n\n\n.dark-mode .dropdown select, \n.dark-mode .dropdown input,\n.dark-mode .search-input {\n  background-color: #333; /* Dark background for input fields */\n  color: #e0e0e0; /* Light text for visibility */\n  border-color: #444; /* Dark border for inputs */\n}\n\nbody.dark-mode .header {\n  background-color: transparent;\n}\n\n.dark-mode .metric-box {\n  background-color: #2c2c2c; /* Darker elements background */\n  color: #e0e0e0; /* Ensure text is legible */\n  padding: 12px 10px; \n}\n\n.dark-mode .metric-box:hover {\n  background-color: #333; /* Slightly lighter on hover for interaction feedback */\n  box-shadow: 0 4px 8px rgba(255, 255, 255, 0.1); /* Soft white glow for depth */\n}\n\n.dark-mode .upload-button:hover,\n.dark-mode .status-button:hover {\n  background-color: #333; /* Slightly lighter on hover for interaction feedback */\n}\n\n.dark-mode .metric-icon {\n  color: #B28DFF; /* Lighter shade for icons */\n}\n\n.dark-mode .metric-text p {\n  color: #cccccc; /* Lighter text color */\n}\n\n.dark-mode .access-management-section {\n  background-color: #1e1e1e; /* Darker shade for cards and sections */\n  color: #e0e0e0;\n  border: 1px solid #333; /* Subtle border for definition */\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); /* Softer shadows */\n}\n\n.dark-mode .profile-of-people-section p,\n.dark-mode .trending-questions p{\n  color: #E6E6FA;\n}\n\n.dark-mode .time-filter select, \n.dark-mode .search-input {\n  background-color: #333; /* Dark background for input fields */\n  color: #e0e0e0; /* Light text for visibility */\n  border-color: #444; /* Dark border for inputs */\n}\n\n.dark-mode .user-category{\n  background-color: transparent;\n}\n\n.dark-mode .user-table,\n.dark-mode .user-subtable{\n  background-color: #2c2c2c; /* Darker shade for cards and sections */\n  color: #e0e0e0;\n}\n\n.dark-mode .user-table th,\n.dark-mode .user-table td {\n  padding: 12px 10px; /* Consistent padding */\n}\n\n.dark-mode .user-table th, \n.dark-mode .user-table td,\n.dark-mode .user-subtable th, \n.dark-mode .user-subtable td {\n  background-color: #2c2c2c; /* Darker background for tables */\n  color: #e0e0e0;\n}\n\n.dark-mode .user-table th {\n  background-color: #333333; /* Slightly lighter for headers */\n  color: #e0e0e0;\n}\n\n.dark-mode .status-button.enabled {\n  background-color: #28a745;\n}\n\n.dark-mode .status-button.disabled {\n  background-color: #dc3545;\n}\n\n.dark-mode .profile-of-people-section {\n  background-color: #1e1e1e; /* Darker shade for cards and sections */\n  color: #e0e0e0;\n  border: 1px solid #333; /* Subtle border for definition */\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); /* Softer shadows */\n}\n\n.dark-mode .trending-questions {\n  background-color: #1e1e1e; /* Darker shade for cards and sections */\n  color: #e0e0e0;\n  border: 1px solid #333; /* Subtle border for definition */\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n}\n\n.dark-mode .trending-questions li {\n  color: #fff;\n}\n.dark-mode .stat[data-tooltip]::after, \n.dark-mode .stat[data-tooltip]::before {\n  background-color: #444444;\n  border-color: #444444 transparent transparent transparent;\n  color: #fff; /* Light text */\n}\n\n.dark-mode .send-button {\n  color: #e0e0e0;\n}\n\n.dark-mode .send-button:hover {\n  color: #4a90e2;\n}\n\n.dark-mode .remove-icon {\n  color: #e0e0e0;\n  background-color: rgba(255, 255, 255, 0.6);\n}\n\n.dark-mode .react-datepicker__input-container input {\n  background-color: #2c2c2c;\n  color: #e0e0e0;\n}\n\n.dark-mode .react-datepicker__day-name,\n.dark-mode .react-datepicker__day,\n.dark-mode .react-datepicker__time-name {\n  color: #ccc;\n}\n\n.dark-mode .react-datepicker__day--selected,\n.dark-mode .react-datepicker__day--keyboard-selected,\n.dark-mode .react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected {\n  background-color: #717ff5;\n  color: #fff;\n}\n\n.dark-mode .dropdown option:selected {\n  background-color: #717ff5; /* Highlight color */\n  color: #fff;\n}\n\n.dark-mode .react-datepicker__day--disabled,\n.dark-mode .react-datepicker__day--excluded {\n  color: #555;\n}\n\n.dark-mode .react-datepicker__navigation-icon {\n  border-color: #717ff5;\n}\n\n.dark-mode .user-subtable th, .dark-mode .user-subtable td {\n  padding: 10px;\n  background-color: #2c2c2c;\n  color: #e0e0e0;\n}\n\n.dark-mode .user-subtable th {\n  background-color: #333333;\n}\n.dark-mode .semi-circle {\n  background: conic-gradient(#00aaff 0deg, #2c2c2c 0deg);\n}\n.dark-mode .percentage-label {\n  color: #fff;\n}\n\n.dark-mode .documents .modal-content{\n  background-color: #2e2e2e; /* Dark background */\n  color: #ffffff; /* Light text color */\n}\n\n.dark-mode .documents .modal-footer, .dark-mode .documents .modal-header{\n  border-color: #444444; /* Dark borders */\n}\n\n.dark-mode .showReport .modal-content{\n  background-color: #2e2e2e; /* Dark background */\n  color: #ffffff; /* Light text color */\n}\n\n.dark-mode .showReport .modal-footer, .dark-mode .documents .modal-header{\n  border-color: #444444; /* Dark borders */\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
